module.exports = __webpack_public_path__ + "static/img/05.85fb073.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/9/05.png
// module id = COgW
// module chunks = 2